module.exports = __webpack_public_path__ + "img/act-of-emotion-inspect-small.e54ffe0a.jpg";